var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 1.5L1.75 4.5V15C1.75 15.3978 1.90804 15.7794 2.18934 16.0607C2.47064 16.342 2.85218 16.5 3.25 16.5H13.75C14.1478 16.5 14.5294 16.342 14.8107 16.0607C15.092 15.7794 15.25 15.3978 15.25 15V4.5L13 1.5H4Z",
    stroke: "#D59CAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 4.5H15.25",
    stroke: "#D59CAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 7.5C11.5 8.29565 11.1839 9.05871 10.6213 9.62132C10.0587 10.1839 9.29565 10.5 8.5 10.5C7.70435 10.5 6.94129 10.1839 6.37868 9.62132C5.81607 9.05871 5.5 8.29565 5.5 7.5",
    stroke: "#D59CAB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.0bbb7d9d2fec24b6db0e0e1959ce2f80.svg";
export { ForwardRef as ReactComponent };